export default function ExclamationOutlinedIcon({
  width = 25,
  height = 24,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      {...props}
    >
      <path
        fill="#454F54"
        fillRule="evenodd"
        d="M12.5 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.75 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.75 17.385 2.75 12Z"
        clipRule="evenodd"
      />
      <path
        fill="#454F54"
        fillRule="evenodd"
        d="M12.5 6.75a.75.75 0 0 1 .75.75v5.25a.75.75 0 0 1-1.5 0V7.5a.75.75 0 0 1 .75-.75Z"
        clipRule="evenodd"
      />
      <path
        fill="#454F54"
        d="M12.5 17.25a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z"
      />
    </svg>
  );
}
